import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MyLifeChangesComponent } from './myLifeChanges.component';
import { Shell } from '@app/shell/shell.service';
import { getRoutePath, PlRoute } from '@app/utils/routes';

const routes: Routes = [
  Shell.childRoutes([
    {
      path: getRoutePath(PlRoute.lifeChanges, false),
      component: MyLifeChangesComponent,
    },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class MyLifeChangesRoutingModule {}
